import React from 'react';
import CrmCommunicationTicketsList, {
  CRM_COMM_MASK_MY_AGENDA,
  CRM_COMM_PAGE_MY_AGENDA,
} from './CrmCommunicationTicketsList';

/** Moja agenda – maska cust019, vlastná user/standard maska. */
export default function CrmCommunicationMyAgendaList(props) {
  return (
    <CrmCommunicationTicketsList
      {...props}
      mineOnlyDefault
      crmTicketsLayout
      listPageKey={CRM_COMM_PAGE_MY_AGENDA}
      maskCode={CRM_COMM_MASK_MY_AGENDA}
    />
  );
}
